import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountState } from '../reducers/account.reducer';
import { AccountRoleEnum } from '@smmof/enum';

/** Селектор состояния аккаунта */
export const selectAccountState = createFeatureSelector<AccountState>('account');

/** Селектор имени аккаунта */
export const selectAccountName = createSelector(selectAccountState, (state) => state.account?.name);

export const selectIsAdmin = createSelector(
  selectAccountState,
  (state) => state.account?.role === AccountRoleEnum.ADMIN,
);

/** Селектор аккаунта */
export const selectAccount = createSelector(selectAccountState, (state) => state.account);

/** Селектор авторизован ли пользователь */
export const selectIsAuthenticated = createSelector(selectAccountState, (state) => state.isAuthenticated);

/** Селектор баланса аккаунта */
export const selectAccountMoney = createSelector(selectAccountState, (state) => Number(state.account?.money));
export const selectAccountMoneyFrozen = createSelector(selectAccountState, (state) => state.account?.moneyFrozen);

/** Селектор статистики лояльности аккаунта */
export const selectLoyaltyStatistics = createSelector(selectAccountState, (state) => state.account?.loyaltyStatistics);
export const selectAccountCurrentReferralPercentage = createSelector(
  selectAccountState,
  (state) => state.account?.loyaltyStatistics?.currentReferralPercentage,
);
export const selectAccountCurrentCommissionPercentage = createSelector(
  selectAccountState,
  (state) => state.account?.loyaltyStatistics?.currentCommissionPercentage,
);

/** Селектор токена доступа */
export const selectAccessToken = createSelector(selectAccountState, (state) => state.token?.accessToken);
